import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import axios from "axios";
//impoertacion componentes
import Solicitudes from "../../Solicitudes";
import {
  creaSolicitud,
  obtenerInstituciones,
  obtenerTipoSolicitud,
} from "../../../Services/Rest";
import Cookies from "universal-cookie";

function CrearSolicitud() {
  const cookies = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [Instituciones, setInstituciones] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerInstituciones,
    })
      .then((Response) => {
        setInstituciones(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setInstituciones]);

  const [Tipo, setTipo] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerTipoSolicitud,
    })
      .then((Response) => {
        setTipo(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setTipo]);

  const [postInstitucion, setPostInstitucion] = useState([]);
  const [postTipo, setPostTipo] = useState({ id: "", nombre: "" });
  const [postCiclo, setPostCiclo] = useState([]);
  const postData = (e) => {
    e.preventDefault();
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: creaSolicitud,
      data: {
        InstitucionId: cookies.get("institucionid"),
        Estado: "En Diligenciamiento",
        TipoSolicitud: postTipo.nombre,
        Ano: new Date().getFullYear(),
        ciclo: postCiclo,
        tipoSolicitudId: postTipo.id,
        TipoEstadoId: 4,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert("solicitud creada con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al cargar la solicitud");
      });
  };
  console.log(postTipo.nombre);
  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-primary "
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Nueva
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Solicitudes"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Proceso De Solicitud
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive"></div>
                  <form className="user">
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          onChange={(e) => {
                            const selectedIndex = e.target.selectedIndex;
                            const selectedOption =
                              e.target.options[selectedIndex];
                            const id = selectedOption.value;
                            const nombre = selectedOption.text;
                            setPostTipo({ id, nombre });
                          }}
                        >
                          <option value="">Seleccione Tipo de Visita</option>
                          {Tipo.map((item) => (
                            <option key={item.Codigo} value={item.id}>
                              {item.codigo + " " + "(" + item.descripcion + ")"}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-sm-6">
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          onChange={(e) => setPostCiclo(e.target.value)}
                        >
                          <option value="">Seleccione Ciclo</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                          <option value="7">7</option>
                          <option value="8">8</option>
                          <option value="9">9</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                          <option value="13">13</option>
                          <option value="14">14</option>
                          <option value="15">15</option>
                          <option value="16">16</option>
                          <option value="17">17</option>
                          <option value="18">18</option>
                          <option value="19">19</option>
                          <option value="20">20</option>
                        </select>
                      </div>
                    </div>
                    <a>
                      <button
                        className="btn btn-primary btn-user btn-block"
                        type="submit"
                        onClick={postData}
                      >
                        Guardar
                      </button>
                    </a>
                    <hr />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default CrearSolicitud;
